<script>
import MessageBox from '@/components/message/MessageBox.vue'
import { mapActions, mapState } from 'vuex'
import AppService from '@/services/app.service'
import { sync } from 'vuex-pathify'

export default {
    name: 'ChatPreview',
    components: { MessageBox },
    data () {
        return {
            isCollapse: false,
            loading: false
        }
    },
    async mounted () {
        AppService.showLoading()
        await this.fetchChatHistory()
        this.jumpToMsg()
        this.initEvents()
        AppService.hideLoading()
        this.$refs.chatBodyRef.$refs.wrap.addEventListener('scroll', this.scroll)
    },
    computed: {
        ...mapState('debug', ['chatHistories', 'sender', 'hasReachMax']),
        requestId: sync('debug/request_id')
    },
    methods: {
        ...mapActions('debug', ['fetchChatHistory']),
        initEvents () {
            document.addEventListener('mouseup', this.mouseUp)
        },
        toggleCollapse () {
            this.$refs.chatPreviewRef.style = ''
            this.isCollapse = !this.isCollapse
        },
        async scroll (e) {
            const wrapEl = this.$refs.chatBodyRef.$refs.wrap
            const isScrollBottom = wrapEl.scrollHeight - wrapEl.scrollTop - wrapEl.clientHeight === 0
            if (isScrollBottom) {
                this.loading = true
                await this.fetchChatHistory()
                this.loading = false
            }
        },
        async jumpToMsg () {
            const requestId = this.$route.query.request_id
            if (requestId) {
                this.requestId = requestId
                if (this.$refs[requestId]) {
                    this.$refs[requestId][0].$el.scrollIntoView({ behavior: 'smooth' })
                } else if (!this.hasReachMax) { // Truong hop lay 30 record trong session nhung khong chua request id
                    this.loading = true
                    await this.fetchChatHistory()
                    this.loading = false
                    await this.jumpToMsg()
                }
            }
        },
        mouseDown (e) {
            document.body.style = '-webkit-user-select: none'
            this.$refs.chatPreviewRef.style.transition = 'initial'
            document.addEventListener('mousemove', this.resize, false)
        },
        mouseUp (e) {
            document.body.style = ''
            this.$refs.chatPreviewRef.style.transition = ''
            document.removeEventListener('mousemove', this.resize, false)
        },
        resize (e) {
            this.$refs.chatPreviewRef.style.flexBasis = e.clientX + 'px'
        }
    },
    beforeDestroy () {
        this.$refs.chatBodyRef.$refs.wrap.removeEventListener('scroll', this.scroll)
    }
}
</script>

<template>
    <div class="chat-preview" :class="{active: !isCollapse}" ref="chatPreviewRef">
        <div class="chat-preview-border" ref="chatPreviewBorderRef" @mousedown="mouseDown"></div>
        <div class="layout-header d-flex align-center justify-center">
            Chat Preview
        </div>
        <div class="collapse-button d-flex align-center" style="cursor: pointer" @click="toggleCollapse">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="102" viewBox="0 0 12 102" fill="none"
                 v-if="isCollapse">
                <path d="M9 51L3 57V45L9 51Z" fill="#7B7B7B"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="102" viewBox="0 0 12 102" fill="none" v-else>
                <path d="M3 51L9 45L9 57L3 51Z" fill="#7B7B7B"/>
            </svg>
        </div>
        <div class="chat-preview-wrapper">
            <div class="heading">Sender Name: {{ sender.sender_name }}</div>
            <div class="chat-body">
                <el-scrollbar ref="chatBodyRef" id="chatBody" class="scroll d-flex flex-column"
                              wrap-class="scroll-wrapper" @scroll.native="scroll">
                    <MessageBox v-for="(history, idx) of chatHistories" :history="history" :key="history.id" :ref="history.request_id" :next-history="chatHistories[idx+1]"/>
                    <div class="d-flex align-center justify-center">
                        <v-progress-circular size="24" :width="3" class="ma-2" v-if="loading"
                            indeterminate
                            color="#d3d3d3"
                        ></v-progress-circular>
                    </div>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.chat-preview-border {
    width: 5px;
    padding: 4px;
    background-color: #EDEDED;
    height: 100%;
    position: absolute;
    right: -3px;
    z-index: 999;
    background-clip: content-box;
    transition: all 0.3s ease;
    &:hover {
        cursor: ew-resize;
    }
}
.layout-header {
    background-color: #F4F4F4;
    padding: 4px 0;
    font-weight: bold;
    color: #7B7B7B;
    position: absolute;
    width: 100%;
    height: 30px;
    overflow: hidden;
}

.chat-preview-wrapper {
    position: absolute;
    height: calc(100% - 30px);
    width: 100%;
    display: flex;
    bottom: 0;
    flex-direction: column;
}

.chat-preview {
    position: relative;
    transition: all 0.3s ease;
    flex: 0 0 0;
    border-radius: 4px;
    border-right: 1px solid #EDEDED;
    background: #EDEDED;
    flex-direction: column;

    &.active {
        flex-basis: 350px;
    }
}

.heading {
    padding: 4px 10px;
    font-weight: bold;
    text-align: center;
    color: #262626;
}

.collapse-button {
    position: absolute;
    width: 12px;
    height: 102px;
    border-radius: 0 4px 4px 0;
    background: #EDEDED;
    z-index: 999;
    right: -12px;
    top: 50%;
}

.chat-body {
    flex-grow: 1;
    position: relative;
    background-color: white;

    .scroll {
        position: absolute;
        height: 100%;
        width: 100%;
    }
}
</style>
<style lang="scss">
.scroll-wrapper {
    overflow-x: hidden !important;
}
</style>
